import { defineComponent, inject, onMounted, onUnmounted, Ref } from 'vue';
import DirectSigninButton from './DirectSigninButton.class';
import { setupComponent } from "@studyportals/vue-platform";
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
export default defineComponent({
	setup: () => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		const isRegister = inject<Ref<boolean>>('isRegister');
		if (!store) throw new Error('IncentiveV2Store not provided');
		if (!isRegister) throw new Error('isRegister was not provided');
		const component = new DirectSigninButton(store, isRegister);

		onMounted(component.mounted.bind(component));
		onUnmounted(component.unmount.bind(component));

		return setupComponent(component);
	},
});
